import { markPendingSignupConfirmation } from './signupConfirmation';

/**
 * Cognito Hosted UI URL helpers.
 *
 * react-oidc-context only wraps the `/oauth2/authorize` (login) endpoint;
 * hosted signup has no client library support, so the URL is built by hand
 * the same way HomePage's original "Get Started" button did.
 */

interface BuildSignUpUrlOptions {
  /**
   * Prefills the email field on the hosted signup form via `login_hint`.
   * Cognito documents `login_hint` for the authorize/login endpoints; support
   * on `/signup` is unverified, so treat this as a nice-to-have — worst case
   * Cognito ignores the param and the visitor just types their email again.
   */
  loginHint?: string;
}

export function buildSignUpUrl(options: BuildSignUpUrlOptions = {}): string {
  markPendingSignupConfirmation();

  const cognitoDomain =
    process.env.REACT_APP_COGNITO_DOMAIN ||
    'https://us-east-1hfkmk8cc4.auth.us-east-1.amazoncognito.com';
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
  const redirectUri = process.env.REACT_APP_COGNITO_REDIRECT_URI || window.location.origin;
  const responseType = process.env.REACT_APP_COGNITO_RESPONSE_TYPE || 'code';
  const scope = 'openid';

  const params = new URLSearchParams({
    client_id: clientId,
    response_type: responseType,
    scope,
    redirect_uri: redirectUri,
  });

  if (options.loginHint) {
    params.set('login_hint', options.loginHint);
  }

  return `${cognitoDomain}/signup?${params.toString()}`;
}
